export default (theme) => ({
  root: {
    backgroundColor: 'transparent',
    textAlign: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  }
})
